import React from 'react';
import classNames from 'classnames';
import { MenuItem as AriaMenuItem, MenuItemProps } from 'react-aria-components';

import * as styles from './Menu.module.scss';

type Props = {
  onClick?: () => void;
} & MenuItemProps;

export const MenuItem = ({ children, className, onClick, ...rest }: Props) => {
  return (
    <AriaMenuItem
      className={classNames(styles.MenuItem, className)}
      onAction={onClick}
      {...rest}
    >
      {children}
    </AriaMenuItem>
  );
};
